<template>
  <div class="task" v-if="ComFinish && ComFinish.items && ComFinish.items.length > 0">
    <span class="task-title">参展任务进度：</span>
    <div class="task-step">
      <div v-for="(item,index) in ComFinish.items" :key="index" class="step-content" @click="link(item)">
        <!-- 审核中 -->
        <div class="step-content-box">
          <Poptip trigger="hover" title="审核中" :word-wrap="true" placement="bottom" :content="item.name" style="height:30%;">
            <i v-if="item.stateId == 0" class="icon iconfont icon-kaishiluping"></i>
          </Poptip>
          <p v-if="item.stateId == 0">{{item.name}}</p>
        </div>
        <div class="line" v-if="item.stateId == 0 && index !== ComFinish.items.length - 1"></div>
        <!-- 已完成 -->
        <div class="step-content-box">
          <div class="task-step-one" v-if="item.stateId == 1">
            <i class="icon iconfont icon-duigou"></i>
          </div>
          <p v-if="item.stateId == 1">{{item.name}}</p>
        </div>
        <div class="line" v-if="item.stateId == 1 && index !== ComFinish.items.length - 1"></div>
        <!-- 未开始 -->
        <div class="step-content-box">
          <Poptip trigger="hover" title="未开始" :word-wrap="true" placement="bottom" :content="item.name" style="height:26px;">
            <i v-if="item.stateId == -1" style="color:#a6a6a6;" class="icon iconfont icon-kaishiluping"></i>
          </Poptip>
          <p v-if="item.stateId == -1">{{item.name}}</p>
        </div>
        <div class="line" v-if="item.stateId == -1 && index !== ComFinish.items.length - 1"></div>
      </div>
    </div>
    <span v-if="finished" style="font-size:14px;color: #b10042;line-height:64px;margin-left:10px;">已完成</span>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data () {
    return {
      ComFinish: null, // stateId：完成状态，-1：未完成，0：进行中，1：已完成
      finished: true, // 是否全部完成
    };
  },
  computed: {
    ...mapGetters({
      company: "loginModule/getCompany",
      joinInfo: "loginModule/getJoinInfo",
    }),
    header () {
      return this.$store.state.header;
    },
  },
  async created () {
    this.getComProcess();
  },
  methods: {
    getComProcess () {
      // 获取公司的完成进度
      this.$http
        .get(
          `/api/join/GetFinishItems?joinId=${this.joinInfo.joinId}`,
          this.header
        )
        .then((res) => {
          if (res.status === 200 && res.data) {
            this.ComFinish = res.data;
            this.ComFinish.items.map((c) => {
              if (c.stateId == -1 || c.stateId == 0) {
                this.finished = false;
              }
            });
          }
        });
    },
    link (e) {
      // 根据finishType字段，跳转至不同页面
      // Embellish = 11：个性化设置提示
      // Release = 12：发布商机提示
      // Product = 13：上传产品提示
      // Activity = 14：申请活动提示
      // Catalogue = 15：提交会刊提示
      // Lintel = 16：提交楣板信息提示,
      // Vehicle = 17：申请车证提示
      // Company = 18：完善公司信息提示
      // Contact = 19：完善联系人提示
      // Invoice = 20：完善开票信息提示
      // Example = 21：上传案例提示
      // Brand = 22：上传品牌提示
      // Cooperation = 23：上传合作伙伴提示
      // 200：证件申请
      if (e.finishType) {
        switch (e.finishType) {
          case 11:
            this.$router.push("/exhibition/index/exinfo/exhibition-info");
            break;
          case 12: // 商机
            break;
          case 13:
            this.$router.push("/exhibition/index/product/allpro");
            break;
          case 14:
            this.$router.push("/exhibition/index/activity/allpro");
            break;
          case 15:
            this.$router.push("/exhibition/index/exinfo/catalogue");
            break;
          case 16:
            this.$router.push("/exhibition/index/exinfo/fascia-board");
            break;
          case 17:
            this.$router.push("/exhibition/index/exinfo/carApply");
            break;
          case 18:
            this.$router.push("/exhibition/index/companyInfo?type=basic");
            break;
          case 19:
            this.$router.push("/exhibition/index/companyInfo?type=link");
            break;
          case 20:
            this.$router.push("/exhibition/index/exinfo/invoice");
            break;
          case 21:
            this.$router.push("/exhibition/index/case/all");
            break;
          case 22:
            this.$router.push("/exhibition/index/brand/allbrand");
            break;
          case 23:
            this.$router.push("/exhibition/index/partner/allpartner");
            break;
          case 200:
            this.$router.push("/exhibition/index/exinfo/certApply");
            break;
        }
      }
    },
  },
};
</script>

<style lang="scss">
.task {
  .ivu-poptip-rel {
    height: 100%;
    display: flex;
    align-items: center;
  }
  .ivu-poptip-popper {
    top: 50px !important;
    width: 230px;
    z-index: 1000;
  }
  .ivu-poptip-title:after {
    display: none;
  }
  .ivu-poptip-title-inner {
    font-size: 12px;
    color: #666;
    text-align: center;
  }
  .ivu-poptip-body-content-inner {
    color: #333;
    font-size: 14px;
    padding: 5px 15px;
    line-height: 24px;
  }
}
</style>
<style scoped lang='scss'>
.task {
  position: relative;
  margin-left: 20px;
  height: 64px;
  display: flex;
  &-title {
    font-size: 14px;
    color: #333;
    display: inline-block;
    width: 120px;
    line-height: 64px;
  }
  &-step {
    max-width: calc(100% - 200px);
    display: flex;
    overflow-x: auto;
    overflow-y: hidden;
    padding: 0 20px;
    &::-webkit-scrollbar {
      /*滚动条整体样式*/
      // width: 10px;     /*高宽分别对应横竖滚动条的尺寸*/
      height: 10px;
    }
    &::-webkit-scrollbar-thumb {
      /*滚动条里面小方块*/
      border-radius: 10px;
      -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
      background: #535353;
    }
    &::-webkit-scrollbar-track {
      /*滚动条里面轨道*/
      -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
      border-radius: 10px;
      background: #ededed;
    }
    .step-content {
      height: 64px;
      display: flex;
      align-items: center;
      &-box {
        height: 58px;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        p {
          cursor: pointer;
          width: 100%;
          text-align: center;
          font-size: 14px;
          line-height: 1.2;
        }
      }
    }
    i {
      font-size: 20px;
      color: #b10042;
      flex: none;
    }
    .line {
      width: 50px;
      height: 2px;
      background-color: #b10042;
      opacity: 0.5;
      flex: none;
    }
    &-one {
      margin: 5px 0;
      flex: none;
      width: 18px;
      height: 18px;
      border-radius: 50%;
      background-color: #b10042;
      display: flex;
      align-items: center;
      justify-content: center;
      i {
        font-size: 14px;
        color: #fff;
      }
    }
  }
}
</style>
